// ============================================================
// KEDBYTE PAYROLL FAQ — same claims policy as payroll.js:
// recognition is in progress (never an outcome), no pricing
// figures, no invented hosting details.
// ============================================================

export const payrollFaq = [
  {
    q: "When does it launch?",
    a: "Upon completion of HMRC PAYE recognition. Join the early-access list and you'll be the first to know — early-access members get first access at launch.",
  },
  {
    q: "What's the HMRC recognition status?",
    a: "Recognition is in progress — our application is with HMRC. The calculation engine already passes every row of HMRC's published 2026-27 payroll test data (1,129 assertions across PAYE, NI and student loans), which is the standard the recognition process tests against.",
  },
  {
    q: "Who is it for?",
    a: "Primarily UK payroll bureaux and accountants running payroll across many client companies — multi-company from the ground up. Small UK employers who run their own payroll are the secondary audience.",
  },
  {
    q: "What will it cost?",
    a: "Pricing is announced at launch. Early-access members hear first, and get first access.",
  },
  {
    q: "Where is my data held?",
    a: "Full hosting and data-residency details are published at launch. What is already built in: a tamper-evident, SHA-256 hash-chained audit log, and immutable committed pay runs.",
  },
];
